import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-089466bc")

_pushScopeId("data-v-089466bc")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "navbar-brand" }, [
  /*#__PURE__*/_createVNode("div", { class: "navbar-item logo" }, "Sparing Timer"),
  /*#__PURE__*/_createVNode("a", {
    role: "button",
    class: "navbar-burger",
    "aria-label": "menu",
    "aria-expanded": "false",
    "data-target": "navbarBasicExample"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }),
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }),
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" })
  ])
], -1)
const _hoisted_2 = {
  id: "navbarBasicExample",
  class: "navbar-menu"
}
const _hoisted_3 = { class: "navbar-start" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-users" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Daily")
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-alt" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Monthly")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-user-clock" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "My work")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-stream" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "My templates")
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-chart-bar" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Absences report")
], -1)
const _hoisted_9 = { class: "navbar-end" }
const _hoisted_10 = { class: "navbar-item has-dropdown is-hoverable user-menu" }
const _hoisted_11 = { class: "navbar-item mobile-user" }
const _hoisted_12 = { class: "image is-24x24 ml-3" }
const _hoisted_13 = { class: "navbar-dropdown" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "image is-16x16",
      src: "https://mattermost.sparing.cloud/static/images/favicon/favicon-32x32.png",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Mattermost")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-cog" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Server settings")
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-users-cog" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Users settings")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-users" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Teams")
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fa fa-download" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Month report")
], -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon has-text-danger" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-sign-out-alt" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Logout")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", {
    class: ["navbar has-text-white-ter", { 'navbar--active': _ctx.$store.state.user.isLogged }],
    role: "navigation",
    "aria-label": "main navigation"
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/daily",
          class: "navbar-item"
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/monthly",
          class: "navbar-item"
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/my-work",
          class: "navbar-item"
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/my-templates",
          class: "navbar-item"
        }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        (_ctx.user.role === 'admin')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/absences-report",
              class: "navbar-item"
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName) + " ", 1),
            _createVNode("figure", _hoisted_12, [
              _createVNode("img", {
                class: "user-picture is-rounded",
                src: _ctx.user.picture,
                alt: ""
              }, null, 8, ["src"])
            ])
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_router_link, {
              to: "/mattermost",
              class: "navbar-item"
            }, {
              default: _withId(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            (_ctx.user.role === 'admin')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/server-settings",
                  class: "navbar-item"
                }, {
                  default: _withId(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.user.role === 'admin')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/users-authorization",
                  class: "navbar-item"
                }, {
                  default: _withId(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.user.role === 'admin')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  to: "/teams",
                  class: "navbar-item"
                }, {
                  default: _withId(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.user.role === 'admin')
              ? (_openBlock(), _createBlock("a", {
                  key: 3,
                  class: "navbar-item",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadHourReport && _ctx.downloadHourReport(...args)), ["prevent"]))
                }, [
                  _hoisted_18
                ]))
              : _createCommentVNode("", true),
            _createVNode("a", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"])),
              class: "navbar-item"
            }, [
              _hoisted_19
            ])
          ])
        ])
      ])
    ])
  ], 2))
})